import { Box, Button, Grid, } from "@mui/material";
import DayPickerInput from "./DayPickerInput";
import RecommendedInput from "./RecommendedInput";
import SipHeader from "./SipHeader";
import { useState } from "react";
import axios from "axios";
import UserSelectTextField from "./UserSelectTextField";
import { toast } from "react-toastify";
import axiosInstance from "../../utils/axiosInstance";

export default function GoldSIP({ metalType, goldPrice, silverPrice, onUserSelect, inputValue, setInputValue,
  sliceResponse, userId, setuserId, formErrors, setFormErrors }) {
  // console.log("sliceResponse: ", sliceResponse);
  // console.log("sliceResponse: in gold", sliceResponse);

  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");





  /////////////////////////////////////////////////// date selecteion //////////////////////
  const [selectedDate, setSelectedDate] = useState("");
  // console.log("selectedDate: ", selectedDate);
  // Callback function to handle the selected date
  const handleDateSelection = (date) => {
    setSelectedDate(date);
    setFormErrors({})
  };
  /////////////////////////////////////////////////// date selecteion End //////////////////////


  /////////////////////////////////////////////////// Amount //////////////////////
  const [amount, setAmount] = useState("");
  const [gramValue, setGramValue] = useState("");
  const handleAmountSelection = (selectedAmount) => {
    setAmount(selectedAmount);
    setFormErrors({});

  };

  /////////////////////////////////////////////////// Amount End  //////////////////////

  // /////////////////////////////////////////////////// User Selection  //////////////////////
  // const [inputValue, setInputValue] = useState("");
  // const [userId, setuserId] = useState("");
  // const handleUserSelection = (user) => {
  //   setuserId(user);
  // };
  // useEffect(() => {
  //   dispatch(userApi());
  // }, [dispatch]);

  // const sliceResponse = useSelector((state) => state.user.user.data);

  // /////////////////////////////////////////////////// User Selection End  //////////////////////
  /////////////////////////////////////////////////// Error handling  //////////////////////

  // error={!!formErrors.SelectPartner}
  // helperText={formErrors.SelectPartner}





  /////////////////////////////////////////////////// Error handling End //////////////////////


  /////////////////////////////////////////////////// Submit Api Call  //////////////////////

  const handleSubmit = async (sendlink) => {


    const errors = {};
    if (!userId || !inputValue) errors.SelectUser = "Select a User";
    // if (!userId) errors.SelectUser = "This is required";
    if (!selectedDate) errors.SelectDate = "Select a date";
    if (amount < 100) errors.SelectAmount = "Minimum amount must be  ≦ 100";
    if (!amount) errors.SelectAmount = "Select an amount";
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    const data = {
      "amount": amount,
      "day_of_month": selectedDate,
      "frequency": "monthly",
      "metal_type": metalType == "Gold" ? "gold" : "silver",
      // "paymentLink": sendlink ? true : false
    }
    try {
      const url = `/sip/${userId}`;
      // const url = `${baseUrl}/sip/${userId}`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axiosInstance.post(url, data);
      // const response = await axios.post(url, data, { headers },);
      const authLink = response?.data?.data?.data?.authLink;
      const { error, message } = response?.data
      if (authLink && sendlink) {
        toast.success("Payment Link send to User Successfully");

        // console.log("link send to user");
        setSelectedDate("")
        setAmount("")
        setuserId("")
        setInputValue("")
        setGramValue("")
      } else if (error && message == "you have not done your kyc !") {
        toast.error("User have not done kyc !");

      } else if (authLink) {
        // Open the authLink in a new tab
        setSelectedDate("")
        setAmount("")
        setuserId("")
        setInputValue("")
        setGramValue("")
        window.open(authLink, "_blank");


      }
    } catch (error) {
      console.log("error: ", error);

    }
  }

  /////////////////////////////////////////////////// Submit Api Call End  //////////////////////

  // "2px solid #4a2a7d"
  return (
    <>
      <Box sx={{ p: {xs:1.5,sm:3}, border: metalType == "Gold" ? "2px solid #dac073" : "2px solid #dadad8", borderRadius: 5 }}>
        <SipHeader metalType={metalType} goldPrice={goldPrice} silverPrice={silverPrice} />

        <Box sx={{ mt: {xs:2,sm:4} }}>
          {/* user selection input field */}
          <UserSelectTextField onUserSelect={onUserSelect} inputValue={inputValue} setInputValue={setInputValue}
            sliceResponse={sliceResponse} userId={userId} setuserId={setuserId} formErrors={formErrors} />
        </Box>
        <Box sx={{ mt: {xs:2,sm:4}}}>
          {/* date selection input field */}
          <DayPickerInput onDateSelect={handleDateSelection} selectedDate={selectedDate} formErrors={formErrors} />
        </Box>
        <Box sx={{ mt: {xs:2,sm:4} }}>
          <RecommendedInput metalType={metalType} goldPrice={goldPrice} silverPrice={silverPrice} onAmountSelect={handleAmountSelection} amount={amount} gramValue={gramValue} setGramValue={setGramValue} formErrors={formErrors} />
        </Box>
        <Box sx={{ m:{ xs: 0.5, sm: 2, md: 3 } }}>
          <Grid container spacing={{xs:1,sm:2}} alignItems="center">
            <Grid item xs={12} md={12} lg={6}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => handleSubmit("Sendlink")}
              >
                Send Link to User
              </Button>
            </Grid>
            <Grid item xs={12} md={12} lg={6} >
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => handleSubmit()}
              >
                Proceed
              </Button>
            </Grid>

          </Grid>
        </Box>
      </Box>
    </>
  );
}
